export enum FilterType {
  RestaurantCategory = 1,
  PricingCategory = 2,
  City = 3,
}
